/// #if PLATFORM === 'xd'
<template>
  <div class="pageLogin">
    <img
      src="@/assets/xd/logo.png"
      class="mt-5 mb-3 logo"
    />

    <div class="pageLoginTitle mb-2">{{ $t('pages.login.title') }}</div>
    <div class="pageLoginDesc mb-3">{{ $t('pages.login.desc') }}</div>

    <form
      class="pageLoginForm"
      @submit.prevent="onSubmit"
    >
      <div class="form-group">
        <input
          type="text"
          class="form-control"
          :placeholder="$t('pages.login.email_ph')"
          v-model="email"
        />
      </div>
      <div class="form-group">
        <!-- <input
          ref="placeholderPassword"
          type="text"
          :placeholder="$t('pages.login.password_ph')"
          class="placeholderPassword"
          v-model="placeholderPassword"
          @keydown="onPlaceholderPasswordKeyDown"
        /> -->
        <input
          ref="password"
          type="password"
          :placeholder="$t('pages.login.password_ph')"
          v-model="password"
        />
      </div>

      <div class="actions">
        <button
          type="submit"
          uxp-variant="cta"
          :disabled="isLoading"
        >{{ $t('buttons.login') }}</button>
      </div>
    </form>

    <a
      href="#"
      class="text-primary"
      @click.prevent="onForgot"
    >{{ $t('buttons.forgot_password') }}</a>

    <div class="pageLoginHelp">{{ $t('pages.login.no_account') }}</div>
    <a
      href="#"
      class="text-primary"
      @click.prevent="onSignup"
    >{{ $t('buttons.signup') }}</a>
  </div>
</template>
/// #else
<template>
  <div class="text-center p-3">
    <div :class="['card', $style.container]">
      <img
        src="@/assets/icons/logo.svg"
        width="150"
        class="mt-5 mb-5"
      />

      <h1 :class="['mb-2', $style.title]">{{ $t('pages.login.title') }}</h1>
      <p class="mb-4">{{ $t('pages.login.desc') }}</p>

      <div class="mt-5 mb-6">
        <button
          :class="['btn btn-primary btn-lg px-4', isLoading ? 'disabled ajax-loading' : '']"
          :disabled="!token"
          type="button"
          @click="onLoginWeb"
        >{{ $t('buttons.login') }}</button>
      </div>

      <a
        href="#"
        class="d-inline-block mt-3 font-weight-normal"
        @click.prevent="onForgot"
      >{{ $t('buttons.forgot_password') }}</a>
    </div>

    <div :class="['mt-4', $style.signupHelp]">
      {{ $t('pages.login.no_account') }}
      <a
        href="#"
        @click.prevent="onSignup"
      >{{ $t('buttons.signup') }}</a>
    </div>
  </div>
</template>
/// #endif

<script>
import { mapActions } from 'vuex'
import Platform from '@/plugin-platforms'
import request from '@/lib/axios'
import { webUrl } from '@/lib/route'

export default {
  mounted () {
    // Clear all data so that user sees a blank information
    this.email = ''
    this.password = ''
    this.placeholderPassword = ''
    this.token = null

    // Create Token to Login with Web
    request({
      route: 'create-token',
      method: 'get',
      params: {
        client_id: Platform.clientId
      }
    }).then(response => {
      this.token = response.data.response.token
    })
  },

  data () {
    return {
      isLoading: false,
      email: null,
      password: '',
      placeholderPassword: '',
      token: null
    }
  },

  watch: {
    placeholderPassword (value) {
      if (value === '' || value === null) {
        this.password = ''
      }
    }
  },

  methods: {
    ...mapActions({
      showMessage: 'message/showMessage'
    }),
    onLoginWeb () {
      this.isLoading = true

      // Open the Iconscout.com with Token & Client Id
      let url = webUrl('login', { client_id: Platform.clientId, token: this.token })
      Platform.openURL(url)

      // Check continuously if user has logged in the web
      const timer = window.setInterval(async () => {
        try {
          // Create Token to Login with Web
          const response = await request({
            route: 'access-token',
            method: 'get',
            params: {
              token: this.token,
              client_id: Platform.clientId
            }
          })

          this.$store.commit('settings/setToken', response.data.response)
          await this.$store.dispatch('settings/load')
          // eslint-disable-next-line
/// #if PLATFORM === 'xd'
          this.$router.push({
            name: 'icons-slug'
          })
          // eslint-disable-next-line
/// #else
          this.$router.push({
            name: 'settings-account'
          })
          // eslint-disable-next-line
/// #endif
          clearInterval(timer)
          this.isLoading = false
        } catch (error) {
          console.log(`Not Logged In yet:`, error.message)
        }
      }, 1500)
    },
    async onSubmit () {
      this.isLoading = true
      this.showMessage({
        message: this.$t('messages.authenticating')
      })

      try {
        let response = await request({
          route: 'login',
          method: 'post',
          data: {
            grant_type: 'password',
            client_id: Platform.clientId,
            client_secret: Platform.clientSecret,
            username: this.email,
            password: this.password
          }
        })

        this.$store.commit('settings/setToken', response.data)
        await this.$store.dispatch('settings/load')
        // eslint-disable-next-line
/// #if PLATFORM === 'xd'
        this.$router.push({
          name: 'icons-slug'
        })
        // eslint-disable-next-line
/// #else
        this.$router.push({
          name: 'settings-account'
        })
        // eslint-disable-next-line
/// #endif
      } catch (e) {
        let message = e.response ? e.response.data.message : e.message
        this.showMessage({
          message,
          type: 'danger'
        })
      } finally {
        this.isLoading = false
      }
    },
    onSignup () {
      let url = webUrl('signup')
      Platform.openURL(url)
    },
    onForgot () {
      let url = webUrl('forgot.password')
      Platform.openURL(url)
    },
    onPlaceholderPasswordKeyDown (e) {
      // Add which for key events
      if (e.which === null && (e.charCode !== null || e.keyCode !== null)) {
        e.which = e.charCode !== null ? e.charCode : e.keyCode
      }

      if (e.key.length === 1) {
        if (e.shiftKey) {
          this.password += e.key.toUpperCase()
        } else {
          this.password += e.key.toLowerCase()
        }
        this.placeholderPassword += '•'

        e.preventDefault()
      } else {
        switch (e.which) {
          case 8:
            const start = this.$refs.placeholderPassword.selectionStart
            const end = this.$refs.placeholderPassword.selectionEnd
            if (start === end) {
              this.password = this.password.substring(0, start - 1) + this.password.substring(start, this.password.length)
              this.placeholderPassword = this.placeholderPassword.substring(0, start - 1) + this.placeholderPassword.substring(start, this.password.length)
            } else {
              this.password = this.password.substring(0, start) + this.password.substring(end, this.password.length)
              this.placeholderPassword = this.placeholderPassword.substring(0, start) + this.placeholderPassword.substring(end, this.password.length)
            }
        }
      }
      console.log(e)
    },
    onLogKeydown (e) {
      const start = this.$refs.password.selectionStart
      const end = this.$refs.password.selectionEnd
      console.log(start, end, e, e.data, e.which, e.code, e.keyCode, e.key, e.charCode, e.keycode)
    }
  }
}
</script>

/// #if PLATFORM !== 'xd'
<style lang="scss" module>
.container {
  // background: var(--bg-3);
  // border: 1px solid var(--border-2);
  // border-radius: $border-radius-lg;
  padding: map-get($spacers, 4);

  .title {
    font-size: $font-size-lg;
    color: var(--typo-1);
  }

  .form {
    max-width: 80%;
    margin: auto;
  }
}
.signupHelp {
  color: var(--typo-3);
  border: 1px solid var(--border-2);
  border-radius: $border-radius-lg;
  padding: map-get($spacers, 4);
  font-size: $font-size-lg;
  font-weight: $font-weight-semi-bold;
}
</style>
/// #endif
